import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import Project from 'models/project/project.model';
import OrganizationUnit from 'models/organization-unit/organization-unit.model';
import { ProjectService } from 'services/project/project.service';

@Component({
  selector: 'app-create-project',
  templateUrl: './create-project.component.html',
  styleUrls: ['./create-project.component.scss'],
})
export class CreateProjectComponent implements OnInit {
  form: FormGroup;
  organizationUnit: OrganizationUnit = new OrganizationUnit();
  subj: Subject<string> = new Subject();

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<CreateProjectComponent>,
    public projectService: ProjectService,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) data,
  ) {
    this.organizationUnit = data.organizationUnit;
    this.subj = data.subj;
  }

  ngOnInit() {
    this.form = this.fb.group({
      name: ['', [Validators.required]],
    });
  }

  async save() {
    try {
      await this.projectService.create(new Project({
        name: this.form.value.name,
        organizationUnit: this.organizationUnit
      }));
      this.snackBar.open('Létrehozás sikeres.', '', {
        duration: 2000
      });
      this.subj.next('saved');
    } catch (ex) {
      console.log('Ex:', ex);
      this.snackBar.open('Létrehozás nem sikerült!', '', {
        duration: 2000
      });
    } finally {
      this.dialogRef.close();
    }
  }

  close() {
      this.dialogRef.close();
  }
}
